import { cn } from "./cn";

export function Avatar({
  initials,
  size = "md",
  className,
}: {
  initials: string;
  size?: "sm" | "md";
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "grid shrink-0 place-items-center rounded-full bg-linear-135 from-brand-light/40 to-brand/40 font-semibold text-brand-ink ring-1 ring-brand/15",
        size === "sm" ? "size-8 text-2xs" : "size-9 text-xs",
        className,
      )}
    >
      {initials}
    </span>
  );
}
